var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon Linkedin",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    "aria-label": "Linkedin icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28094",
    d: "M17.5 0A17.5 17.5 0 110 17.5 17.5 17.5 0 0117.5 0z",
    fill: "var(--color-secondary-dark)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14630",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 36506",
    d: "M11.1 8a2.1 2.1 0 102.1 2.1A2.1 2.1 0 0011.1 8z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2603",
    d: "M9.289 13.793h3.622v11.654H9.289z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 36507",
    d: "M22.132 13.503a3.806 3.806 0 00-3.427 1.882h-.048v-1.592h-3.475v11.653h3.619v-5.765c0-1.52.289-2.992 2.174-2.992 1.857 0 1.882 1.738 1.882 3.09v5.667h3.619v-6.392c0-3.134-.677-5.551-4.344-5.551z"
  }))));
}
export default SvgLinkedin;